
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities/search/initial",
      function () {
        return require("private-next-pages/facilities/search/initial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities/search/initial"])
      });
    }
  